import React from 'react'
import {DropTarget} from 'react-dnd'
import withScrolling from 'react-dnd-scrollzone';
import Preview, {Context} from 'react-dnd-preview'

import EditorHeader from './header/Header'
import EditorPanel from './panel/Panel'
import EditorPreview from './preview/Preview'
import EditorModal from './modal/Modal'
import AppModal from '../modal/Modal'

import ConfigHelper from '../helpers/Config'
import WbtHelper from '../helpers/Wbt'

import '../../styles/editor.scss'

const ScrollingComponent = withScrolling('div');

function editorCollect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  }
}

class Editor extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      wbt: {},
      panelModuleId: '',
      panelElementId: '',
      panelView: 'elements',
      isSaved: true,
      modalShow: false,
      modalArgs: {},
      tempArgs: {},
      isDragOverPreview: false,
      actions: [],
      previewMode: true,
      responsiveMode: false,
      overlayId: '',
      appModal: '',
      appModalShow: false,
      appModalData: {}
    }
  }

  componentDidMount() {
    this.loadWbt()
  }

  async loadWbt() {
    const {
      match: {
        params
      }
    } = this.props

    var wbt = await WbtHelper.getWbt(params.wbtId)
    if(wbt !== null) {
      this.setState({
        wbt: wbt
      }, () => {
        this.updateActions('')
      })
    } else {
      this.props.history.push('/wbts')
    }
  }

  handleSave() {
    WbtHelper.saveWbt(this.state.wbt)
    this.setState({
      isSaved: true
    })
  }

  handleDuplicate(args) {
    var wbt = this.state.wbt
    wbt = WbtHelper.duplicate(args, wbt)
    this.setState({
      wbt: wbt,
      isSaved: false
    }, () => {
      var label
      if(args.elementId !== undefined) {
        label = 'Element dupliziert'
      } else {
        label = 'Modul dupliziert'
      }
      this.updateActions(label)
    })
  }

  handleDelete(args) {
    var wbt = this.state.wbt
    wbt = WbtHelper.delete(args, wbt)
    var state = {
      wbt: wbt
    }
    if(args.columnElementId === undefined) {
      state.panelModuleId = ''
      state.panelElementId = ''
      state.panelView = 'elements'
    }
    this.setState(state)
    this.setState({
      isSaved: false
    }, () => {
      var label
      if(args.elementId !== undefined) {
        label = 'Element gelöscht'
      } else {
        label = 'Modul gelöscht'
      }
      this.updateActions(label)
    })
  }

  handleEdit(args) {
    if(args.elementId !== undefined) {
      this.setState({
        panelModuleId: args.moduleId,
        panelElementId: args.elementId,
        panelView: 'edit'
      })
    } else if(args.moduleId !== undefined) {
      this.setState({
        panelModuleId: args.moduleId,
        panelElementId: '',
        panelView: 'edit'
      })
    }
  }

  handleEditEnd() {
    this.setState({
      panelView: 'elements'
    }, () => {
      this.updateActions('Element bearbeitet')
    })
  }

  handleAdd(args) {
    var wbt = this.state.wbt
    wbt = WbtHelper.add(args, wbt)
    this.setState({
      wbt: wbt,
      panelView: 'elements',
      isSaved: false
    }, () => {
      var label
      var config = ConfigHelper.getElementConfig(args.elementType)
      if(args.elementType !== undefined) {
        label = config.title + ' erstellt'
      } else {
        label = 'Modul erstellt'
      }
      this.updateActions(label)
    })
  }

  handleAddInside(args) {
    var wbt = this.state.wbt
    wbt = WbtHelper.addInside(args, wbt)
    this.setState({
      wbt: wbt,
      isSaved: false
    }, () => {
      this.updateActions('Element erstellt')
    })
  }

  handleMove(source, target) {
    var wbt = this.state.wbt
    wbt = WbtHelper.move({
      source: source,
      target: target
    }, wbt)
    this.setState({
      wbt: wbt,
      isSaved: false
    }, () => {
      var label
      if(source.elementId !== undefined) {
        label = 'Element verschoben'
      } else {
        label = 'Modul verschoben'
      }
      this.updateActions(label)
    })
  }

  handleMoveInside(source, target) {
    var wbt = this.state.wbt
    wbt = WbtHelper.moveInside({
      source: source,
      target: target
    }, wbt)
    this.setState({
      wbt: wbt,
      isSaved: false
    }, () => {
      this.updateActions('Element verschoben')
    })
  }

  handleOpenModal(args) {
    var filter = ''
    if(args.filter !== undefined) {
      filter = args.filter
    }
    this.setState({
      modalShow: true,
      modalArgs: {
        modal: 'attachment',
        filter: filter
      },
      tempArgs: args,
      isSaved: false
    })
  }

  handleOpenSettings() {
    this.setState({
      modalShow: true,
      modalArgs: {
        modal: 'settings'
      }
    })
  }

  handleSelectFile(id) {
    var wbt = this.state.wbt
    var args = this.state.tempArgs
    args.fieldValue = id
    if(args.field !== undefined && args.field === 'wbt_image') {
      wbt.settings.image = args.fieldValue
      this.setState({
        wbt: wbt,
        modalShow: true,
        modalArgs: {
          modal: 'settings'
        },
        tempArgs: {},
        isSaved: false
      })
    } else {
      if(this.state.overlayId !== '') {
        args.overlayId = this.state.overlayId;
      }
      if(args.itemId !== undefined) {
        console.log('args1')
        console.log(args)
        wbt = WbtHelper.changeFieldItem(args, wbt)
      } else {
        console.log('args12')
        console.log(args)
        wbt = WbtHelper.changeField(args, wbt)
      }
      console.log(wbt)
      this.setState({
        wbt: wbt,
        modalShow: false,
        modalArgs: {},
        tempArgs: {},
        isSaved: false
      }, () => {
        this.updateActions('Bild ausgewählt')
      })
    }
  }

  handleCloseModal() {
    this.setState({
      modalShow: false,
      modalArgs: {},
      tempArgs: {},
      appModal: '',
      appModalShow: false
    })
  }

  handleChangeField(args) {
    var wbt = this.state.wbt
    if(args.fieldName === 'wbt_image') {
      wbt.settings.image = args.fieldValue
    } else {
      if(this.state.overlayId !== '') {
        args.overlayId = this.state.overlayId;
      }
      wbt = WbtHelper.changeField(args, wbt)
    }
    this.setState({
      wbt: wbt,
      isSaved: false
    })
  }

  handleChangeOrder(args) {
    var wbt = this.state.wbt
    wbt = WbtHelper.changeOrder(args, wbt)
    this.setState({
      wbt: wbt
    })
    this.setState({
      isSaved: false
    })
  }

  handleChangeModuleHeadline(args) {
    var wbt = this.state.wbt
    wbt = WbtHelper.changeModuleHeadline(args, wbt)
    this.setState({
      wbt: wbt,
      isSaved: false
    })
  }

  handleDragOverPreview(state) {
    this.setState({
      isDragOverPreview: state
    })
  }

  handleChangeSettings(args) {
    var wbt = this.state.wbt
    wbt = WbtHelper.changeSettings(args, wbt)
    this.setState({
      wbt: wbt,
      modalShow: false,
      modalArgs: {}
    }, () => {
      this.handleSave()
    })
  }

  updateActions(action) {
    var actions = this.state.actions
    var selectedActionIndex = -1
    actions.forEach(function(action, i) {
      if(action.selected) {
        actions[i].selected = false
        selectedActionIndex = i
      }
    })
    selectedActionIndex--
    if(selectedActionIndex >= 0) {
      for(var i = selectedActionIndex; i >= 0; i--) {
        actions.splice(i, 1);
      }
    }
    if(action === '') {
      actions.push({
        label: '',
        selected: false,
        savedWbt: this.state.wbt
      });
    } else {
      actions[0].label = action
      actions.unshift({
        label: '',
        selected: false,
        savedWbt: this.state.wbt
      });
    }
    if(actions.length > 21) {
      actions = actions.slice(0, 21)
    }
    this.setState({
      actions: actions
    })
  }

  handleSelectAction(index) {
    var actions = this.state.actions
    var actionSelectedIndex = -1
    actions.forEach((action, i) => {
      if(i === index + 1) {
        actions[i].selected = !actions[i].selected
        if(actions[i].selected) {
          actionSelectedIndex = i
        }
      } else {
        actions[i].selected = false
      }
    })
    if(actionSelectedIndex !== -1) {
      this.setState({
        wbt: actions[actionSelectedIndex].savedWbt,
        actions: actions
      })
    } else {
      this.setState({
        wbt: actions[0].savedWbt,
        actions: actions
      })
    }
  }

  handleSelectResponsiveMode(mode) {
    this.setState({
      responsiveMode: mode
    })
  }

  handleSelectRevision(revision) {
    var wbt = this.state.wbt
    wbt.modules = revision.content.modules
    this.setState({
      wbt: wbt,
      isSaved: false,
      modalShow: false,
      modalArgs: {}
    })
  }

  handleTogglePreviewMode() {
    this.setState({
      panelView: 'elements',
      previewMode: !this.state.previewMode
    })
  }

  handleAddTemplate() {
    this.setState({
      modalShow: true,
      modalArgs: {
        modal: 'add_template',
        wbt: this.state.wbt,
        wbtId: this.state.wbt.id
      }
    })
  }

  handleSaveAsTemplate(args) {
    this.setState({
      modalShow: true,
      modalArgs: {
        modal: 'add_module_template',
        wbt: this.state.wbt,
        moduleId: args.moduleId
      }
    })
  }

  handleOpenHelpVideo(video) {
    this.setState({
      appModal: 'help_video',
      appModalShow: true,
      appModalData: {
        video: video
      }
    })
  }

  handleCloseOverlay() {
    this.setState({
      overlayId: ''
    })
  }

  render() {
    const {
      match: {
        params
      }
    } = this.props
    return this.props.connectDropTarget(
      Object.keys(this.state.wbt).length !== 0 ?
        <div id="editor" className={'preview' + (this.state.overlayId !== '' ? ' overlay-mode' : '')}>
          { /* <EditorHeader
            type={this.state.wbt.type}
            actions={this.state.actions}
            settings={this.state.wbt.settings}
            isSaved={this.state.isSaved}
            previewMode={this.state.previewMode}
            onSave={this.handleSave.bind(this)}
            onOpenSettings={this.handleOpenSettings.bind(this)}
            onSelectAction={this.handleSelectAction.bind(this)}
            onTogglePreviewMode={this.handleTogglePreviewMode.bind(this)}
            onAddTemplate={this.handleAddTemplate.bind(this)}
            onSelectResponsiveMode={this.handleSelectResponsiveMode.bind(this)}
          /> */ }
          <EditorPanel
            wbt={this.state.wbt}
            view={this.state.panelView}
            moduleId={this.state.panelModuleId}
            elementId={this.state.panelElementId}
            previewMode={this.state.previewMode}
            onEditEnd={this.handleEditEnd.bind(this)}
            onOpenModal={this.handleOpenModal.bind(this)}
            onChangeField={this.handleChangeField.bind(this)}
            onChangeOrder={this.handleChangeOrder.bind(this)}
            onOpenHelpVideo={this.handleOpenHelpVideo.bind(this)}
            overlayId={this.state.overlayId}
          />
          <EditorPreview
            type={this.state.wbt.type}
            responsiveMode={this.state.responsiveMode}
            wbt={this.state.wbt}
            previewMode={this.state.previewMode}
            panelModuleId={this.state.panelModuleId}
            panelElementId={this.state.panelElementId}
            panelView={this.state.panelView}
            onDuplicate={this.handleDuplicate.bind(this)}
            onDelete={this.handleDelete.bind(this)}
            onEdit={this.handleEdit.bind(this)}
            onEditEnd={this.handleEditEnd.bind(this)}
            onAdd={this.handleAdd.bind(this)}
            onAddInside={this.handleAddInside.bind(this)}
            onMove={this.handleMove.bind(this)}
            onMoveInside={this.handleMoveInside.bind(this)}
            onChangeField={this.handleChangeField.bind(this)}
            onChangeModuleHeadline={this.handleChangeModuleHeadline.bind(this)}
            onDragOverPreview={this.handleDragOverPreview.bind(this)}
            onSaveAsTemplate={this.handleSaveAsTemplate.bind(this)}
            overlayId={this.state.overlayId}
            onOpenHelpVideo={this.handleOpenHelpVideo.bind(this)}
            onCloseOverlay={this.handleCloseOverlay.bind(this)}
          />
          <EditorModal
            wbtId={params.wbtId}
            actions={this.state.actions}
            settings={this.state.wbt.settings}
            onChangeSettings={this.handleChangeSettings.bind(this)}
            modalShow={this.state.modalShow}
            modalArgs={this.state.modalArgs}
            onOpenModal={this.handleOpenModal.bind(this)}
            onSelectFile={this.handleSelectFile.bind(this)}
            onCloseModal={this.handleCloseModal.bind(this)}
            onSelectAction={this.handleSelectAction.bind(this)}
            onChangeField={this.handleChangeField.bind(this)}
            onSelectRevision={this.handleSelectRevision.bind(this)}
          />
          <AppModal
            modal={this.state.appModal}
            modalShow={this.state.appModalShow}
            modalData={this.state.appModalData}
            onCloseModal={this.handleCloseModal.bind(this)}
          />
          <Preview>
            <Context.Consumer>
              {
                ({itemType, item, style}) => {
                  if(this.state.isDragOverPreview || (item.moduleId !== undefined && !this.props.isOver)) {
                    style.top = '63px'
                    style.left = '316px'
                  }
                  if(item.moduleId !== undefined) {
                    style.margin = '-43px 0 0 -43px'
                  }
                  return(
                    <div className={'drag-preview is-dragging type-' + item.itemType} style={style}>
                      <div className="drag-preview-container">
                        {
                          item.icon !== undefined ?
                            <div className="icon">{item.icon}</div>
                          :
                            null
                        }
                        <div className="label">{item.label}</div>
                        <div className="background"></div>
                      </div>
                    </div>
                  )
                }
              }
            </Context.Consumer>
          </Preview>
        </div>
      :
        null
    )
  }
}


export default DropTarget(
  ['column-element', 'element', 'module'],
  {},
  editorCollect
)(Editor)
